import LazyLoad from "vanilla-lazyload"

export const lazyLoading = new LazyLoad({
  elements_selector: "[data-src], [data-bg]",
  callback_loaded: (element) => {
    element.closest(".img.--placeholder")?.classList.remove("--placeholder")
  },
})
